// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  takeId: __t.u64().primaryKey().name("take_id"),
  bountyId: __t.u64().name("bounty_id"),
  hunter: __t.identity(),
  state: __t.string(),
  takenAt: __t.timestamp().name("taken_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
